var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "bank_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.18 19.98h-1.11v-8.01c.81-.02 1.52-.51 1.8-1.27.29-.76.07-1.61-.52-2.13l-6.39-5.93a3.025 3.025 0 0 0-3.97.02l-6.33 5.9c-.61.54-.82 1.38-.53 2.14a1.96 1.96 0 0 0 1.86 1.28h.08v8H3.82c-.55 0-1 .45-1 1s.45 1 1 1h16.36c.55 0 1-.45 1-1s-.45-1-1-1m-7.11-8v8h-2v-8zm2 0h2v8h-2zM4.98 10.06l6.35-5.92c.19-.17.43-.25.67-.25s.45.08.62.23l6.39 5.85-14.03.08zm2.09 1.92h2v8h-2z"
})));
export default SvgBank;